<h1 class="page-title">Verify Credentials</h1>

<div *ngIf="!isPractitionerActive">
  <h2 class="error-message">It looks like your status is inactive.</h2>
  <p><a routerLink="/purchase/annual-renewal">Click here</a> to activate your status to view this content.</p>
  <p>Your active status gives you access to the directory of active credentialed practitioners, the Horizons Newsletter
    and reduced prices on products.</p>
</div>
<app-directory *ngIf="isPractitionerActive" [showAllPractitioners]="false"></app-directory>
